var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 204,
    viewBox: "0 0 62.706 53.975",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.81521 0 0 .8126 -.74454 -.74275)",
    fill: "#aaa",
    fillRule: "evenodd",
    stroke: "#aaa",
    strokeWidth: 0.17164
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.907 18.569h15.882v-15.073h-15.882zm-1.241 2.496h8.065v13.098h2.482v-13.098h7.817c0.684 0 1.24-0.56 1.24-1.248v-17.569c0-0.689-0.556-1.248-1.24-1.248h-18.364c-0.686 0-1.24 0.56-1.24 1.248v17.569c0 0.689 0.554 1.248 1.24 1.248zm1.241 43.676h15.882v-15.605h-15.882zm17.123-18.189h-7.941v-4.81h-2.482v4.81h-7.941c-0.686 0-1.24 0.58-1.24 1.292v18.19c0 0.713 0.554 1.291 1.24 1.291h18.364c0.684 0 1.24-0.578 1.24-1.292v-18.189c0-0.713-0.556-1.292-1.24-1.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.754 64.704h16.426v-15.834h-16.426zm-55.187 0h16.428v-15.834h-16.428zm72.898-18.456h-8.215v-7.932c0-0.723-0.575-1.31-1.284-1.31h-55.7c-0.71 0-1.283 0.587-1.283 1.31v7.932h-7.7c-0.71 0-1.284 0.587-1.284 1.311v18.456c0 0.723 0.574 1.31 1.283 1.31h18.995c0.708 0 1.283-0.587 1.283-1.31v-18.456c0-0.724-0.575-1.31-1.283-1.31h-8.727v-6.622h53.133v6.621h-8.213c-0.71 0-1.283 0.587-1.283 1.311v18.456c0 0.723 0.574 1.31 1.283 1.31h18.995c0.708 0 1.283-0.587 1.283-1.31v-18.456c0-0.724-0.575-1.31-1.283-1.31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.645667ec42af689136b2adde14537531.svg";
export { ForwardRef as ReactComponent };